import { Component } from '@angular/core';

import { Alert, AlertType } from 'app/models';
import { MainService } from 'app/services';

@Component({
	moduleId: module.id,
	selector: 'alert',
	templateUrl: 'alert.component.html',
	styleUrls: ['./alert.component.css']
})
export class AlertComponent {
	alerts: Alert[] = [];

	constructor(private mainService: MainService) { }

	ngOnInit() {
		this.mainService.alertService.getAlert().subscribe((alert: Alert) => {
			if (!alert) {
				this.alerts = [];
				return;
			}
			this.alerts.push(alert);
		});
	}

	removeAlert(alert: Alert) {
		this.alerts = this.alerts.filter(x => x !== alert);
	}

	cssClass(alert: Alert) {
		if (!alert) {
			return;
		}
		switch (alert.type) {
			case AlertType.Success:
				return 'alert alert-success';
			case AlertType.Error:
				return 'alert alert-danger';
			case AlertType.Info:
				return 'alert alert-info';
			case AlertType.Warning:
				return 'alert alert-warning';
		}
	}

	cssClassBtn(alert: Alert) {
		if (!alert) {
			return;
		}
		switch (alert.type) {
			case AlertType.Success:
				return 'btn btn-success';
			case AlertType.Error:
				return 'btn btn-danger';
			case AlertType.Info:
				return 'btn btn-info';
			case AlertType.Warning:
				return 'btn btn-warning';
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/alert/alert.component.ts